// components/startProject/StartWhyOglitz.jsx
import { FiTarget, FiShield, FiTrendingUp, FiUsers } from "react-icons/fi";
import "./why.css";

export default function StartWhyOglitz() {
  return (
    <section className="sp-why">
      <div className="sp-why-inner">
        <span className="sp-why-badge">Why Oglitz</span>

        <h2 className="sp-why-title">
          Build Confidently with a <br />
          <span>Trusted Software Development Partner</span>
        </h2>

        <p className="sp-why-intro">
          Oglitz Software partners with startups and enterprises to design,
          develop, and scale custom software solutions. Our focus is not just
          delivery — but long-term product success, performance, and growth.
        </p>

        <div className="sp-why-grid">
          {/* FIRST – Light highlight */}
          <div className="sp-why-card sp-why-card-highlight">
            <div className="sp-why-icon">
              <FiTarget />
            </div>
            <h4>Business-First Engineering</h4>
            <p>
              Every technical decision is aligned with your business goals,
              users, and growth strategy — not just features.
            </p>
          </div>

          <div className="sp-why-card">
            <div className="sp-why-icon">
              <FiShield />
            </div>
            <h4>Secure & Scalable Architecture</h4>
            <p>
              We build future-ready systems with strong security, clean code,
              and scalable foundations.
            </p>
          </div>

          <div className="sp-why-card">
            <div className="sp-why-icon">
              <FiUsers />
            </div>
            <h4>Transparent Collaboration</h4>
            <p>
              Dedicated project manager, clear milestones, and continuous
              communication at every stage.
            </p>
          </div>

          {/* LAST – Dark highlight */}
          <div className="sp-why-card sp-why-card-highlight">
            <div className="sp-why-icon">
              <FiTrendingUp />
            </div>
            <h4>Long-Term Growth Partnership</h4>
            <p>
              Beyond launch, we support scaling, optimization, and continuous
              improvement as your product grows.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
